/*
 * @Author: liqian
 * @description: 
 * @param: 
 * @return: 
 */
/*
 * 短信列表 *
 * *
 * */
import { collectionServiceClient } from "@/api/collectionServiceClient";
import { GetSmsTaskIdMapReq } from "@/pbjs/xcommon/collection_pb";
import { Page } from "@/utils/index";
import { setPage } from "@/utils/request";
import InnerRequest from "./request";
interface RoleOptions {
  trackId?: string;
  clientId?: string;
  token: string;
  caseLevel: string;
  taskcallResult: number;
  taskTarget: string;
  phoneObject: number;
  repayinclination: number;
  adminuId: number;
  orderId: string;
  appname: string;
}
export interface Options {
  UserGroupId?: number;
  PayrollCycleCondition?: number;
  IsNewEmployee?: number;
  EmployeeId?: string;
  EmployeeName?: string;
  Page: Page;
}
export function setGetSmsTaskIdMapReq(arg: RoleOptions) {
  // string TrackId = 1;
  // string ClientId = 2;
  // string Token = 3;
  // string CaseLevel = 4; // 案件等级
  // int32 TaskCallResult = 5; // 呼叫结果:1 已接通 0:未接通
  // string TaskTarget = 6; // 短信任务类型:urge 催收 remind 提醒
  // int32 PhoneObject = 7; // 拨打对象
  // int64 AdminUid = 8;
  let request: any = new GetSmsTaskIdMapReq();
  request.setCaselevel(arg.caseLevel);
  request.setTaskcallresult(Number(arg.taskcallResult));
  request.setTasktarget(arg.taskTarget);
  request.setPhoneobject(Number(arg.phoneObject));
  request.setRepayinclination(+arg.repayinclination);
  request.setOrderid(arg.orderId);
  request.setAppname(arg.appname);
  console.log("setGetSmsTaskIdMapReq", arg, request);
  return request;
}
export const getSmsTaskIdMapRequest = new InnerRequest(
  collectionServiceClient,
  collectionServiceClient.getSmsTaskIdMap
);
